import {getState} from '../store.type';

export const LECTURE_COLORS = [
    '#FF9999', '#FFBB99', '#FFDD99', '#FFEE99', '#D2E7A8',
    '#DCF5AA', '#AAF3DA', '#68DBDD', '#99BBFF', '#CC99FF'
];

export const pickNextLectureColor = (): string => {
    const lectures = getState().timetable.lectures;
    let count = 0;
    for(const dayLectures of Object.values(lectures)) {
        for(const l of dayLectures) {
            if(!l.isBreak) count++;
        }
    }
    return LECTURE_COLORS[count % LECTURE_COLORS.length];
};
